import { useState } from 'react';

export default function FacilityInspection() {
  const [selectedFacility, setSelectedFacility] = useState('岸桥');

  const inspectionRecords = [
    { id: 'FB001', name: '1号岸桥', type: '岸桥', lastInspection: '2024-01-15 09:30', status: '正常', issues: 0, nextInspection: '2024-01-22' },
    { id: 'FB002', name: '2号岸桥', type: '岸桥', lastInspection: '2024-01-15 10:15', status: '轻微隐患', issues: 2, nextInspection: '2024-01-22' },
    { id: 'FB003', name: '3号场桥', type: '场桥', lastInspection: '2024-01-15 11:00', status: '正常', issues: 0, nextInspection: '2024-01-22' },
    { id: 'FB004', name: '4号场桥', type: '场桥', lastInspection: '2024-01-15 14:20', status: '正常', issues: 0, nextInspection: '2024-01-22' },
    { id: 'FB005', name: '5号岸桥', type: '岸桥', lastInspection: '2024-01-15 15:45', status: '严重隐患', issues: 5, nextInspection: '2024-01-18' },
  ];

  const hazardList = [
    { id: 'HZ001', facility: '2号岸桥', location: '主梁连接处', type: '结构裂纹', severity: '中', discoveryTime: '2024-01-15 10:20', status: '待处理' },
    { id: 'HZ002', facility: '2号岸桥', location: '吊臂支撑点', type: '螺栓松动', severity: '低', discoveryTime: '2024-01-15 10:25', status: '待处理' },
    { id: 'HZ003', facility: '5号岸桥', location: '轨道连接段', type: '结构裂纹', severity: '高', discoveryTime: '2024-01-15 15:50', status: '紧急处理中' },
    { id: 'HZ004', facility: '5号岸桥', location: '电缆桥架', type: '腐蚀严重', severity: '高', discoveryTime: '2024-01-15 15:55', status: '紧急处理中' },
    { id: 'HZ005', facility: '5号岸桥', location: '主梁焊缝', type: '焊缝开裂', severity: '高', discoveryTime: '2024-01-15 16:00', status: '紧急处理中' },
  ];

  const filteredRecords = selectedFacility === '全部' 
    ? inspectionRecords 
    : inspectionRecords.filter(r => r.type === selectedFacility);

  return (
    <div className="space-y-6">
      {/* 统计卡片 */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        <div className="bg-gray-800/50 backdrop-blur-sm rounded-lg p-6 border border-teal-500/20">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm text-gray-400">今日巡检设施</span>
            <i className="ri-building-line text-2xl text-teal-400"></i>
          </div>
          <div className="text-3xl font-bold text-white mb-1">12</div>
          <div className="text-xs text-teal-400">+3 较昨日</div>
        </div>

        <div className="bg-gray-800/50 backdrop-blur-sm rounded-lg p-6 border border-teal-500/20">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm text-gray-400">发现隐患</span>
            <i className="ri-alert-line text-2xl text-orange-400"></i>
          </div>
          <div className="text-3xl font-bold text-white mb-1">7</div>
          <div className="text-xs text-orange-400">需及时处理</div>
        </div>

        <div className="bg-gray-800/50 backdrop-blur-sm rounded-lg p-6 border border-teal-500/20">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm text-gray-400">巡检覆盖率</span>
            <i className="ri-pie-chart-line text-2xl text-green-400"></i>
          </div>
          <div className="text-3xl font-bold text-white mb-1">94.5%</div>
          <div className="text-xs text-green-400">本周平均</div>
        </div>

        <div className="bg-gray-800/50 backdrop-blur-sm rounded-lg p-6 border border-teal-500/20">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm text-gray-400">待处理隐患</span>
            <i className="ri-time-line text-2xl text-red-400"></i>
          </div>
          <div className="text-3xl font-bold text-white mb-1">5</div>
          <div className="text-xs text-red-400">2个紧急</div>
        </div>
      </div>

      {/* 巡检画面 */}
      <div className="bg-gray-800/50 backdrop-blur-sm rounded-lg p-6 border border-teal-500/20">
        <h3 className="text-lg font-semibold text-white mb-4 flex items-center gap-2">
          <i className="ri-camera-line text-teal-400"></i>
          实时巡检画面
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="relative rounded-lg overflow-hidden h-48">
            <img 
              src="https://public.readdy.ai/ai/img_res/603b9f8fe6417768fcdc0d6ace570a46.jpg"
              alt="岸桥巡检"
              className="w-full h-full object-cover"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-3">
              <div className="text-white text-sm font-medium">2号岸桥主梁检查</div>
              <div className="text-teal-400 text-xs">发现裂纹 - 2024-01-15 10:20</div>
            </div>
          </div>
          <div className="relative rounded-lg overflow-hidden h-48">
            <img 
              src="https://readdy.ai/api/search-image?query=port%20gantry%20crane%20structural%20inspection%20showing%20support%20beams%20and%20rail%20connections%2C%20aerial%20drone%20view%2C%20industrial%20equipment%20detail%2C%20bright%20daylight%20photography%2C%20technical%20documentation%20style%2C%20metal%20framework%20close-up&width=600&height=400&seq=facility-inspect-002&orientation=landscape"
              alt="场桥巡检"
              className="w-full h-full object-cover"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-3">
              <div className="text-white text-sm font-medium">3号场桥轨道检查</div>
              <div className="text-green-400 text-xs">状态正常 - 2024-01-15 11:00</div>
            </div>
          </div>
          <div className="relative rounded-lg overflow-hidden h-48">
            <img 
              src="https://readdy.ai/api/search-image?query=industrial%20crane%20bolt%20and%20connection%20inspection%20extreme%20close-up%2C%20showing%20loose%20bolts%20and%20fasteners%2C%20technical%20inspection%20photography%2C%20detailed%20metal%20hardware%2C%20professional%20documentation%20angle%2C%20clear%20focus%20on%20mechanical%20components&width=600&height=400&seq=facility-inspect-003&orientation=landscape"
              alt="螺栓检查"
              className="w-full h-full object-cover"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-3">
              <div className="text-white text-sm font-medium">5号岸桥螺栓检查</div>
              <div className="text-orange-400 text-xs">发现松动 - 2024-01-15 15:55</div>
            </div>
          </div>
        </div>
      </div>

      {/* 巡检记录 */}
      <div className="bg-gray-800/50 backdrop-blur-sm rounded-lg p-6 border border-teal-500/20">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-white flex items-center gap-2">
            <i className="ri-file-list-line text-teal-400"></i>
            设施巡检记录
          </h3>
          <div className="flex items-center gap-2">
            <button
              onClick={() => setSelectedFacility('全部')}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                selectedFacility === '全部' 
                  ? 'bg-teal-500 text-white' 
                  : 'bg-gray-700/50 text-gray-300 hover:bg-gray-700'
              }`}
            >
              全部
            </button>
            <button
              onClick={() => setSelectedFacility('岸桥')}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                selectedFacility === '岸桥' 
                  ? 'bg-teal-500 text-white' 
                  : 'bg-gray-700/50 text-gray-300 hover:bg-gray-700'
              }`}
            >
              岸桥
            </button>
            <button
              onClick={() => setSelectedFacility('场桥')}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                selectedFacility === '场桥' 
                  ? 'bg-teal-500 text-white' 
                  : 'bg-gray-700/50 text-gray-300 hover:bg-gray-700'
              }`}
            >
              场桥
            </button>
          </div>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-gray-700">
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">设施编号</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">设施名称</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">类型</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">最近巡检</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">状态</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">隐患数</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">下次巡检</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">操作</th>
              </tr>
            </thead>
            <tbody>
              {filteredRecords.map((record) => (
                <tr key={record.id} className="border-b border-gray-700/50 hover:bg-gray-700/30 transition-colors">
                  <td className="py-3 px-4 text-sm text-white">{record.id}</td>
                  <td className="py-3 px-4 text-sm text-white">{record.name}</td>
                  <td className="py-3 px-4 text-sm text-gray-300">{record.type}</td>
                  <td className="py-3 px-4 text-sm text-gray-300">{record.lastInspection}</td>
                  <td className="py-3 px-4">
                    <span className={`px-3 py-1 rounded-full text-xs font-medium ${
                      record.status === '正常' ? 'bg-green-500/20 text-green-400' :
                      record.status === '轻微隐患' ? 'bg-orange-500/20 text-orange-400' :
                      'bg-red-500/20 text-red-400'
                    }`}>
                      {record.status}
                    </span>
                  </td>
                  <td className="py-3 px-4 text-sm">
                    <span className={record.issues > 0 ? 'text-red-400 font-medium' : 'text-gray-400'}>
                      {record.issues}
                    </span>
                  </td>
                  <td className="py-3 px-4 text-sm text-gray-300">{record.nextInspection}</td>
                  <td className="py-3 px-4">
                    <button className="text-teal-400 hover:text-teal-300 text-sm cursor-pointer whitespace-nowrap">
                      查看详情
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* 隐患列表 */}
      <div className="bg-gray-800/50 backdrop-blur-sm rounded-lg p-6 border border-teal-500/20">
        <h3 className="text-lg font-semibold text-white mb-4 flex items-center gap-2">
          <i className="ri-error-warning-line text-orange-400"></i>
          隐患详细列表
        </h3>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-gray-700">
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">隐患编号</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">所属设施</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">位置</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">隐患类型</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">严重程度</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">发现时间</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">处理状态</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">操作</th>
              </tr>
            </thead>
            <tbody>
              {hazardList.map((hazard) => (
                <tr key={hazard.id} className="border-b border-gray-700/50 hover:bg-gray-700/30 transition-colors">
                  <td className="py-3 px-4 text-sm text-white">{hazard.id}</td>
                  <td className="py-3 px-4 text-sm text-white">{hazard.facility}</td>
                  <td className="py-3 px-4 text-sm text-gray-300">{hazard.location}</td>
                  <td className="py-3 px-4 text-sm text-gray-300">{hazard.type}</td>
                  <td className="py-3 px-4">
                    <span className={`px-3 py-1 rounded-full text-xs font-medium ${
                      hazard.severity === '低' ? 'bg-blue-500/20 text-blue-400' :
                      hazard.severity === '中' ? 'bg-orange-500/20 text-orange-400' :
                      'bg-red-500/20 text-red-400'
                    }`}>
                      {hazard.severity}
                    </span>
                  </td>
                  <td className="py-3 px-4 text-sm text-gray-300">{hazard.discoveryTime}</td>
                  <td className="py-3 px-4">
                    <span className={`px-3 py-1 rounded-full text-xs font-medium ${
                      hazard.status === '待处理' ? 'bg-yellow-500/20 text-yellow-400' :
                      'bg-red-500/20 text-red-400'
                    }`}>
                      {hazard.status}
                    </span>
                  </td>
                  <td className="py-3 px-4">
                    <button className="text-teal-400 hover:text-teal-300 text-sm cursor-pointer whitespace-nowrap">
                      处理
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}